import React, { useMemo } from 'react';
import Avatar from '@mui/material/Avatar';


type Props = {
    userName?: string;
    showEmptyImage?: boolean;
    url?: string | null | undefined;
    width?: number;
    height?: number;
    tag?: keyof JSX.IntrinsicElements;
    [key: string]: any;
}

export const ProfileImageRounded = ({
    userName,
    showEmptyImage = true,
    url,
    width = 25,
    height = 25,
    tag = 'div',
}: Props) => {
    if (!url && !showEmptyImage) {
        return null;
    }

    return useMemo(() => {
        let image = <Avatar alt="image" sx={{width, height }} component={tag} />;
        if (url) {
            image = <Avatar src={url} alt="image" sx={{width, height }} component={tag} />;
        } else if (userName && userName.length) {
            const [firstChar, secondChar] = userName.trim().toUpperCase().split(' ').map((part) => part[0]);

            if (firstChar) {
                let hash = 0;
                hash = firstChar.charCodeAt(0) + ((hash << 5) - hash);
                if (secondChar) {
                    hash = secondChar.charCodeAt(0) + ((hash << 5) - hash);
                }

                const hue = hash % 360;
                const saturation = 30 + (hash % 20);
                const lightness = 70 + (hash % 10);

                const backgroundColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
                image = (
                    <Avatar
                        component={tag}
                        sx={{width, height, backgroundColor, fontSize: Math.floor(width / 2) }} color="white"
                    >{firstChar}{secondChar || ''}
                    </Avatar>
                );
            }
        }

        return image;
    }, [userName, width, height, url]);
};
